"use strict";

exports.__esModule = true;
exports.default = void 0;

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENTS = Symbol('events');
var log = (0, _debug.default)('events');

var events = /*#__PURE__*/function () {
  /**
   *
   * @type {{Array}}
   */
  function events(component) {
    this[EVENTS] = {};
    this.ID = Date.now();
    this.component = void 0;
    log('constructor', component.constructor.name);
    this.component = component;
  }
  /**
   *
   * @param name
   * @param listener
   */


  var _proto = events.prototype;

  _proto.removeListener = function removeListener(name, listener) {
    if (typeof listener == "function") {
      var _events4 = this[EVENTS][name];

      if (_events4) {
        var index = _events4.indexOf(listener);

        if (index > -1) {
          log('removeListener', this.component.constructor.name, name, listener._debugID);

          _events4.slice(index, 1);
        }
      }
    }

    return this;
  };

  _proto.addListener = function addListener(name, listener) {
    if (typeof listener == "function") {
      var _events5 = this[EVENTS][name] = this[EVENTS][name] || [];

      log('addListener', this.component.constructor.name, name, listener._debugID);

      _events5.push(listener);
    }

    return this;
  };

  _proto.emit = function emit(name) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _events3 = this[EVENTS][name];

    if (_events3) {
      _events3.forEach(function (caller) {
        log('emit', _this.component.constructor.name, name, caller._debugID);
        caller.apply(void 0, args);
      });
    }
  };

  _proto.listeners = function listeners(name) {
    return this[EVENTS][name];
  };

  return events;
}();

exports.default = events;
module.exports = exports.default;